export const BUILD_ID_HEADER = 'X-Build-Id'

const RELOADED_FOR_KEY = 'reloadedForBuildId'

export const shouldReload = (
  serverBuildId: string | null | undefined,
  ownBuildId: string | null | undefined,
  reloadedFor: string | null
) =>
  !!serverBuildId &&
  !!ownBuildId &&
  serverBuildId !== ownBuildId &&
  reloadedFor !== serverBuildId

// The server sends the entry script path of the front-end build it ships. When it differs from the script
// this tab is running, the tab is stale and reloads once. The session marker stops a reload loop if the
// reload does not bring the new build.
export const reloadIfStale = (serverBuildId: string | null | undefined) => {
  const ownBuildId = document
    .querySelector('script[type="module"][src]')
    ?.getAttribute('src')
  try {
    const reloadedFor = sessionStorage.getItem(RELOADED_FOR_KEY)
    if (!shouldReload(serverBuildId, ownBuildId, reloadedFor)) return
    sessionStorage.setItem(RELOADED_FOR_KEY, serverBuildId as string)
  } catch {
    return
  }
  window.location.reload()
}
